import React, { PropsWithChildren } from 'react';

import clsx from 'clsx';

import { Container, ContainerProps } from '@atoms';

import { ColorName, colors } from '@styles';

import classes from './section.module.scss';

type Props = PropsWithChildren<{
  id?: string;
  className?: string;
  background?: ColorName;
  withoutPadding?: boolean;
}> &
  ContainerProps;

export const Section = ({
  children,
  className,
  background = 'white',
  id,
  withoutPadding,
  ...containerProps
}: Props) => {
  if (!children) return null;

  return (
    <section
      className={clsx(
        classes.section,
        withoutPadding && classes.noPadding,
        className,
      )}
      id={id}
      style={{ backgroundColor: colors[background].hex() }}
    >
      {/* CONTENT */}
      <Container {...containerProps} className={classes.container}>
        {children}
      </Container>
    </section>
  );
};
